<div class="modal-header">
  <h4 class="modal-title landing-crop-title" id="landing-crop-title">Image Configuration</h4>
  <button type="button" class="btn-close" aria-label="Close" title="Close Modal" (click)="cancel()"></button>
</div>

<!-- Canon's mt-3 above the content. Height is capped but not pinned: the editor states its own
     gaps and reserves room for them, so pinning min-height would only add dead space. -->
<div class="modal-body mt-3 d-flex flex-column" [style.max-height.px]="stageHeight">
  <app-mini-menu-crop-editor [imageSource]="imageSource" [frames]="frames" [crops]="working"
                             [stageMaxHeight]="stageHeight" (readyChange)="onCropReady($event)"
                             (loadError)="imageLoadFailed = true" (cropsChange)="onCropsChange($event)">
    <div class="landing-crop-links">
      <button type="button" class="landing-crop-link" title="Replace this image" [disabled]="isCompressing"
              (click)="landingReplace.click()">Replace</button>
      <button type="button" class="landing-crop-link is-destructive" title="Remove this image" [disabled]="isCompressing"
              (click)="remove()">Remove</button>
      <input type="file" #landingReplace accept="image/*,.heic,.heif" hidden [disabled]="isCompressing" (change)="onReplace($event)"
             (click)="landingReplace.value = ''" />
    </div>
  </app-mini-menu-crop-editor>
</div>

<!-- Canon footer: one centred primary action at half width. -->
<div class="modal-footer d-flex justify-content-center border-top-0 mb-2 pt-0">
  <button type="button" class="btn btn-primary upload-btn w-50" [disabled]="isCompressing || imageLoadFailed || !isCropReady" (click)="confirm()">
    {{ isCompressing ? 'Preparing photo…' : 'Confirm Image Crop' }}
  </button>
</div>
